import { Injectable, signal } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { IBaseModel } from '../models/base.model';
import { IUserStatusModel, IUserProfileModel } from '../models/user.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom } from 'rxjs';
import { Utils } from '../shared/utils';
import { Enums } from '../shared/enums';
import { ToastrService } from 'ngx-toastr';
import { AcessoCidadaoService } from './acesso-cidadao.service';

@Injectable()
export class AuthService extends BaseService {
    controllerRoute = 'User';

    public $user = signal(null as IUserProfileModel);

    constructor(
        httpClient: HttpClient,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private acessoCidadaoService: AcessoCidadaoService,
    ) {
        super(httpClient);
    }

    public async getUserProfile(showLoading = false): Promise<IBaseModel<IUserProfileModel>> {
        if (this.$user() != null && Object.keys(this.$user()).length > 0) {
            return Promise.resolve({ isSuccess: true, data: this.$user() } as IBaseModel<IUserProfileModel>);
        } else {
            try {
                if (showLoading) {
                    this.spinner.show('root');
                }

                const response = await firstValueFrom(this.httpClient.get<IBaseModel<IUserProfileModel>>(`${this.apiBaseUrl}/${this.controllerRoute}/Profile`));

                if (!response.isSuccess) {
                    this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                    this.$user.set(null);
                    return;
                }

                Utils.setSignal(this.$user, response.data);
                return response;
            } catch (error) {
                this.$user.set(null);
                throw (error);
            } finally {
                this.spinner.hide('root');
            }
        }
    }

    public async getStatus(): Promise<IBaseModel<IUserStatusModel>> {
        return await firstValueFrom(this.httpClient.get<IBaseModel<IUserStatusModel>>(`${this.apiBaseUrl}/${this.controllerRoute}/Status`));
    }

    public logout() {
        window.location.replace('/Account/Logout');
    }

    public login() {
        window.location.replace('/Account/Login?returnUrl=' + window.location);
    }

    public hasProfiles(profiles: string[]) {
        return this.$user()?.perfis
            && profiles.some(p => this.$user().perfis.map(x => x.trim().toLowerCase()).includes(p.trim().toLowerCase()));
    }

    public async isAdmin() {
        const response = await this.acessoCidadaoService.getUnidadesPerfilAdministrador(this.$user().id);
        if (!response.isSuccess) {
            this.toastr.error(response.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }
        let adminUnitsList = response.data;

        return adminUnitsList?.length > 0
            || this.hasProfiles([Enums.Profiles.AdminAll]);
    }
}
